import React, { useEffect } from "react";
import "../IndexPage/IndexPage.css";

function WhiskyPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div className="whisky-background"></div>
      <div className="card-container">
        <img loading="lazy" decoding="async" width="1061" height="1500" className="pdf-sake" src="img/whisky.webp" alt="Whisky japonés"></img>
      </div>
    </div>
  );
}

export default WhiskyPage;
